<template>
    <div :class="['section', b_bottom ? 'b-bottom' : '']">
        <div class="section__inner">
            <div class="section__header" v-if="title">
                <div class="container">
                    <div class="row between section__header-row v-center">
                        <div class="col section__header-col section__header-col-left">
                            <div class="row v-center">
                                <h2 class="col section__header-title">{{ title }}</h2>
                                <slot name="header_left"></slot>
                            </div>
                        </div>
                        <div class="col section__header-col section__header-col-right">
                            <slot name="header_right"></slot>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section__body">
                <slot name="body"></slot>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'AppSection',
    props: {
        title: {
            type: String,
            default: '',
        },
        b_bottom: {
            type: Boolean,
            default: false,
        }
    },
    setup: (props, ctx) => {

        return {

        }
    },
}
</script>

<style lang="scss">
    .section {
        padding: 80px 0;
        width: 100%;
        
        @include tablet {
            position: relative;
            padding: 45px 0;
        }

        @include mobile {
            padding: 30px 0;
        }

        &.b-bottom {
            border-bottom: 1px solid var(--c-gray-700);
        }

        &__header {
            margin-bottom: 32px;
            font-size: 14px;

            @include tablet {
                font-size: 12px;
                margin-bottom: 24px;
            }

            &-title {
                margin: 0;
            }
        }
    }
</style>
